import { startRegistration, startAuthentication } from '@simplewebauthn/browser';
import { supabase } from './supabase';

// Huella / Face ID verificada en el servidor (función 'webauthn'). El servidor guarda la clave pública y comprueba cada firma.
const call = async (action, extra = {}) => {
  const { data, error } = await supabase.functions.invoke('webauthn', { body: { action, ...extra } });
  if (error) {
    let msg = 'No se pudo verificar la huella';
    let code = '';
    try { const b = await error.context.json(); msg = b.error || msg; code = b.error || ''; } catch (e) { /* sin cuerpo */ }
    const err = new Error(code === 'no_credential' ? 'no_credential' : msg);
    err.code = code;
    throw err;
  }
  return data;
};

const friendly = (e) => {
  if (e?.name === 'NotAllowedError') return new Error('Cancelaste la verificación o venció el tiempo. Probá de nuevo.');
  if (e?.name === 'InvalidStateError') return new Error('Este dispositivo ya tiene tu huella registrada.');
  return e;
};

export const getBioStatus = async () => {
  const { data, error } = await supabase.rpc('my_bio_status');
  if (error) throw error;
  return data;
};

export const serverBioRegister = async () => {
  if (!window.PublicKeyCredential) throw new Error('Tu navegador no soporta huella / Face ID');
  try {
    const options = await call('reg-options');
    const response = await startRegistration(options);
    await call('reg-verify', { response });
    return true;
  } catch (e) { throw friendly(e); }
};

export const serverBioVerify = async () => {
  if (!window.PublicKeyCredential) throw new Error('Tu navegador no soporta huella / Face ID');
  try {
    const options = await call('auth-options');
    const response = await startAuthentication(options);
    await call('auth-verify', { response });
    return true;
  } catch (e) { throw friendly(e); }
};

// Verifica; si todavía no hay credencial en el servidor, la registra (el alta también exige huella / Face ID)
export const serverBioEnsure = async () => {
  const st = await getBioStatus();
  if (!st?.server_credential) return serverBioRegister();
  try { return await serverBioVerify(); }
  catch (e) { if (e.message === 'no_credential') return serverBioRegister(); throw e; }
};
